export const decisioningStudioAgentsAppGroupIdDsaIdConstraints =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/constraints";
